import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { WebflowSignupFlowControllerPage } from './webflow-signup-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: WebflowSignupFlowControllerPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebflowSignupFlowControllerPageRoutingModule {}
